<template>
  <div id="app">
    <router-view />
    <transition name="fade" mode="out-in">
      <Loading v-if="isLoading" />
    </transition>
    <!-- <a
      href="https://api.whatsapp.com/send?phone=6285285890090"
      target="_blank"
      class="whatsapp text-white bg-neutral-600 shadow-base transition-all hover:bg-neutral-700 cursor-pointer rounded-full fixed z-60 bottom-8 right-8 w-16 h-16 flex items-center justify-center"
    >
      <Whatsapp width="32" height="32" />
    </a> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { detectMobile } from '@/util'
export default {
  components: {
    Loading: () => import(/* webpackChunkName: "loading" */ '@/components/Illustration/Loading'),
    // Whatsapp: () => import(/* webpackChunkName: "icons" */ '@/components/Icons/Whatsapp')
  },
  computed: {
    ...mapGetters('common', ['isLoading', 'isMobile'])
  },
  async mounted() {
    this.checkPlatform()
  },
  methods: {
    checkPlatform() {
      if (detectMobile()) {
        this.$store.commit('common/setIsMobile', true)
      } else {
        this.$store.commit('common/setIsMobile', false)
      }
    }
  }
}
</script>
